import { useState } from "react";

import { PageTitle } from "../../components/PageTitle";
import { formatNumber } from "../../utils/NumbersFormatting";
import ApiKeyPage from "./components/ApiKeyPage/ApiKeyPage";
import GenerateApiKey from "./components/GenerateApiKey/GenerateApiKey";

const settingsBreadcrumbs = [
  {
    title: "Organization",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const ApiKeyWrapper = () => {
  const [keysAmount, setKeysAmount] = useState<number>(0);
  return (
    <>
      <div className="wrapper-header-export-btn-question-history">
        <PageTitle
          breadcrumbs={settingsBreadcrumbs}
          breadcrumbTitle="Keys"
          pageTitle={`API Keys ${
            keysAmount ? `(${formatNumber(keysAmount)})` : ""
          }`}
        />
        <GenerateApiKey />
      </div>
      <ApiKeyPage setKeysAmount={setKeysAmount} />
    </>
  );
};

export { ApiKeyWrapper };
